/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ShapeCircleMOffIcon20Regular = forwardRef('ShapeCircleMOffIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.03 1.97a.75.75 0 0 0-1.06 1.06L4.548 5.61a7 7 0 0 0 9.843 9.843l2.579 2.578a.75.75 0 1 0 1.06-1.06l-15-15Zm10.293 12.413L5.617 6.677a5.5 5.5 0 0 0 7.706 7.706Z" }),
        React.createElement("path", { d: "M15.5 10c0 .626-.105 1.228-.297 1.789l1.151 1.151A7 7 0 0 0 7.06 3.645l1.153 1.152A5.5 5.5 0 0 1 15.5 10Z" })));
});
